import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { PermissionConst } from 'src/app/core/models/permission-const.model';
import { ProfessionalsService } from 'src/app/core/services/professionals.service';
import { SessionManagerService } from 'src/app/core/services/session-manager.service';
import { documentsStringFormatter, phoneNumberStringFormatter } from 'src/app/core/utils/string-formatters';
import { ListTemplate } from 'src/app/shared/renderers/models/list-template';

@Component({
  selector: 'app-professionals-list',
  templateUrl: './professionals-list.component.html',
  styleUrls: ['./professionals-list.component.scss']
})
export class ProfessionalsListComponent implements OnInit {

  searchString: string = "";
  orderingItem: string = "name";

  request?: Subscription;

  get clinicId() {
    if (this.isSuperUserOrStaff) {
      return '';
    }
    return this.sessionManager.getClinicCurrent().value?.toString();
  }

  clinicIdList: string = "";

  get canNewData() {
    const permissions = [PermissionConst.add_tag, PermissionConst.change_tag, PermissionConst.view_tag];
    return permissions.every((p) => this.sessionManager.getUserPermission(p));
  }

  get canExport() {
    const permissions = [PermissionConst.export_tag, PermissionConst.change_tag, PermissionConst.view_tag];
    return permissions.every((p) => this.sessionManager.getUserPermission(p));
  }

  get isSuperUserOrStaff() {
    return this.sessionManager.isSuperUserOrStaff();
  }

  listTemplate: ListTemplate = {
    loading: true,
    showSearch: true,
    searchBarPlaceholder: "Buscar por Nome ou CPF",
    showAdvancedSearch: false,
    newDataText: "+ Novo Profissional",
    newDataRouterLink: this.canNewData || this.isSuperUserOrStaff ? "register" : undefined,
    notFoundMessage: "Nenhum profissional encontrado",
    clickRowClickHandle: true,
    header: [
      { name: "name", label: "Nome", widthInPercentage: "45%", width: "300px" },
      { name: "document_number", label: "CPF", widthInPercentage: "25%", width: "150px", displayStringConvertionFunction: documentsStringFormatter },
      { name: "phone_numbers", label: "Telefone", widthInPercentage: "30%", width: "200px", displayStringConvertionFunction: phoneNumberStringFormatter }],
    onHeaderItemClick: (value: string) => {
      let invertString = '';
      if (this.orderingItem == value) {
        this.listTemplate.invertedOrdering = !this.listTemplate.invertedOrdering;
        if (this.listTemplate.invertedOrdering)
          invertString = '-';
      }
      let clinicId = this.clinicIdList != '' ? this.clinicIdList : this.clinicId;
      this.fetchList(this.searchString, `${invertString}${value}`, clinicId, this.listTemplate.is_active);
      this.orderingItem = value;
      this.listTemplate.selectedOrdering = value;
    },
    onSearchFocusOut: (value: string) => {
      this.searchString = value;
      let clinicId = this.clinicIdList != '' ? this.clinicIdList : this.clinicId;
      this.fetchList(this.searchString, this.orderingItem, clinicId, this.listTemplate.is_active);
    },
    onClickActive: !this.isSuperUserOrStaff ? undefined : () => {
      this.listTemplate.is_active = !this.listTemplate.is_active;
      let clinicId = this.clinicIdList != '' ? this.clinicIdList : this.clinicId;
      this.fetchList(this.searchString, this.orderingItem, clinicId, this.listTemplate.is_active);
    },
    onClinicFocusOut: (value: string) => {
      this.clinicIdList = value;
      let clinicId = this.clinicIdList != '' ? this.clinicIdList : this.clinicId;
      this.fetchList(this.searchString, this.orderingItem, clinicId, this.listTemplate.is_active);
    },
    selectedOrdering: this.orderingItem,
    invertedOrdering: false,
    exportUrl: this.canExport ? '/professionals/export' : undefined,
    exportOptions: {
      id: 'ID',
      phone_numbers: 'Telefones',
      name: 'Nome',
      display_name: 'Nome de tratamento',
      gender: 'Gênero',
      birthdate: 'Data de nascimento',
      email: 'E-mail',
      document_number: 'CPF',
      cro: 'CRO',
      tags: 'Tags',
      specialties: 'Áreas de atuação'
    }
  };

  constructor(private professionalService: ProfessionalsService, private sessionManager: SessionManagerService, private titleService: Title) {
    this.titleService.setTitle('Chega de Ronco - Profissionais');
  }

  ngOnInit(): void {
    this.initializeList();
  }


  initializeList() {
    this.fetchList("", "name", this.clinicId, this.listTemplate.is_active);
  }

  fetchList(searchString: string, orderingItem: string, clinicId: string, isActive: boolean | undefined) {
    this.listTemplate.loading = true;
    this.listTemplate.data = undefined;

    if (this.request) {
      this.request.unsubscribe();
    }
    this.request = this.professionalService.list(searchString, orderingItem, clinicId, isActive).subscribe(response => {
      this.listTemplate.loading = false;
      this.listTemplate.data = response;
      this.listTemplate.hasNext = response.next != null;
    }, (error) => {
      const response = error as HttpErrorResponse;
      this.listTemplate.loading = false;
      this.listTemplate.error = true;
      this.listTemplate.errorMessage = response.error['detail'];
    });
  }

  loadMore(page: number) {
    this.listTemplate.loadingNext = true;
      let clinicId = this.clinicIdList != '' ? this.clinicIdList : this.clinicId;
      this.professionalService.list(this.searchString, this.orderingItem, clinicId, this.listTemplate.is_active, page).subscribe(response => {
      this.listTemplate.hasNext = response.next != null;
      response.results!.map(item => this.listTemplate.data!.results!.push(item));
      this.listTemplate.loadingNext = false;
    }, (error) => {
      const response = error as HttpErrorResponse;
      this.listTemplate.loading = false;
      this.listTemplate.error = true;
      this.listTemplate.errorMessage = response.error['detail'];
    });
  }
}
